/**
 * Meeting notes provider configuration and error messages
 */

export const FATHOM_ERROR_MESSAGES: Record<string, string> = {
  oauth_error: 'Fathom denied access. Please try connecting again.',
  access_denied: 'You denied access to Fathom. Please try connecting again.',
  user_mismatch: 'Authentication error. Please log in and try again.',
  token_exchange_failed:
    "We couldn't complete Fathom authentication. Try again.",
  token_exchange_timeout: 'Fathom authentication timed out. Please try again.',
  no_access_token: 'Fathom returned an incomplete response. Please try again.',
  user_info_failed: "We couldn't fetch your Fathom account info. Try again.",
  user_info_timeout:
    'Fetching Fathom account info timed out. Please try again.',
  // NOTE: webhook_setup_failed / webhook_registration_failed removed deliberately.
  // fathom_callback no longer aborts the connection when Fathom's /webhooks call
  // fails — it logs and creates the integration anyway, because the reconciliation
  // poll syncs the same recordings over the REST API. Neither code is emitted now.
};

export const DEFAULT_FATHOM_ERROR_MESSAGE =
  'An unexpected error occurred while connecting to Fathom. Please try again or contact support.';

export const GRANOLA_ERROR_MESSAGES: Record<string, string> = {
  oauth_error: 'Granola denied access. Please try connecting again.',
  access_denied: 'You denied access to Granola. Please try connecting again.',
  user_mismatch: 'Authentication error. Please log in and try again.',
  token_exchange_failed:
    "We couldn't complete Granola authentication. Try again.",
  dcr_failed: "We couldn't register with Granola. Try again later.",
};

export const DEFAULT_GRANOLA_ERROR_MESSAGE =
  'An unexpected error occurred while connecting to Granola. Please try again or contact support.';

export const FIREFLIES_ERROR_MESSAGES: Record<string, string> = {
  oauth_error: 'Fireflies denied access. Please try connecting again.',
  access_denied: 'You denied access to Fireflies. Please try connecting again.',
  user_mismatch: 'Authentication error. Please log in and try again.',
  token_exchange_failed:
    "We couldn't complete Fireflies authentication. Try again.",
  dcr_failed: "We couldn't register with Fireflies. Try again later.",
  identity_unconfirmed:
    'Could not verify your Fireflies account. Please try again.',
  rate_limited:
    'Fireflies is temporarily busy. Please wait a moment and try again.',
  account_already_linked:
    'This Fireflies account is already connected to another user.',
  invalid_state:
    'Your Fireflies connection attempt expired. Please try connecting again.',
  integration_not_found:
    'Your Fireflies integration was removed mid-connect. Please try connecting again.',
};

export const DEFAULT_FIREFLIES_ERROR_MESSAGE =
  'An unexpected error occurred while connecting to Fireflies. Please try again or contact support.';
